'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:CartCtrl
 * @description
 * # CheckoutCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('CheckoutCtrl', function ($scope, $q, $window, $location, $timeout, $uibModal, Analytics, session, api, stripe3ds, BUILD_DATE, COUNTRIES, BILLING_PERIODS) {

		const startTime = new Date().getTime();

		/**
		 * @type ShoppingCart
		 */
		$scope.cart = {}

		/**
		 * @type PaymentData
		 */
		$scope.paymentData = {}

		function extendedPrice(item) {
			return item.unitPrice * item.qty;
		}

		/**
		 * @param callbackFn returns an amount for a cartAction's lineItem
		 */
		function cartActionLineItemSum(callbackFn) {
			return lineItemSum($scope.cartActions, callbackFn);
		}

		/**
		 * @param cartActions {CartAction[]}
		 * @param callbackFn returns an amount for a cartAction's lineItem
		 */
		function lineItemSum(cartActions, callbackFn) {
			return cartActions
				.reduce(function (sum, eachAction) {
					try {
						return sum + eachAction.lineItems.reduce(function (subSum, lineItem) {
							return subSum + callbackFn(lineItem) || 0;
						}, 0);
					} catch (e) {
						console.error('Could not evaluate', callbackFn, 'on', cartActions, e);
						return 0;
					}
				}, 0);
		}

		function redirectIfCartActionsIsEmpty() {
			if ($scope.cartActions.length === 0) {
				toastr.info('Your cart is empty!');
				$location.path('/');
			}
		}

		$scope.companyInputTitle = function () {
			return $scope.cart.companyOverride ?
				'Upgrades must be registered to the same company name' :
				!$scope.isFree() ?
					'License will be registered to this company' :
					'';
		};

		$scope.totalWithoutPromo = function () {
			return cartActionLineItemSum(extendedPrice);
		};

		$scope.totalOrderPrice = function () {
			return $scope.totalWithoutPromo() - $scope.promoDollarAmount();
		};

		$scope.isFree = function () {
			return $scope.totalOrderPrice() === 0;
		};

		$scope.isRenewal = function () {
			return $scope.cartActions.some(function (cartAction) {
				return cartAction.action === 'Renew';
			});
		};

		$scope.isInvalidPaymentMethod = () => {
			return !$scope.isFree() && $scope.paymentData.paymentMethod !== 'creditCard' && ($scope.cart.autoRenew || $scope.isAnnualSubscription());
		};

		$scope.invalidPaymentMethodMessage = () => {
			if ($scope.isAnnualSubscription()) {
				return 'Subscriptions renew automatically and require a credit card. Please change your payment type.';
			}
			return 'Automatic renewal is only supported for Credit Card payment types. Please change your payment type, or choose manual renewal at the top of the page.';
		};

		$scope.promoName = function () {
			const promo = $scope.cart.promoCode;
			if (!promo) {
				return null;
			} else if (promo.affiliate) {
				return 'Affiliate code for ' + promo.affiliateUser.company;
			} else {
				return promo.name;
			}
		};

		$scope.promoDollarAmount = function () {
			const promo = $scope.cart.promoCode;
			if (!promo) {
				return null;
			}
			if (promo.affiliate && !session.account) {
				return null; // must log in to apply affiliate code
			} else if ($scope.cart.commissionChoice === 'Check') {
				return 0; // no discount
			} else if (promo.creditAmount) {
				return promo.creditAmount;
			} else if (promo.creditPercent) {
				if (!promo.variant) { // discount applies to entire order
					return Math.round($scope.totalWithoutPromo() * promo.creditPercent) / 100;
				} else { // discount applies to a single item
					const eligibleItem = $scope.cart.cartItems.find(function (action) {
						return action.variantId === promo.variant.id;
					});
					return Math.round(extendedPrice(eligibleItem) * promo.creditPercent) / 100;
				}

			} else {
				return null; // something fishy about this one
			}
		};

		// function eligibleForAutoRenew(i) {
		// 	return i.product.version.eligibleForAutoRenew &&
		// 		i.product.variantType.code !== 'RENEWAL' &&
		// 		i.product.variantType.code !== 'DEMO' &&
		// 		i.product.variantType.code !== 'FREE';
		// }


		$scope.manualRenewPrice = function () {
			return cartActionLineItemSum(function (item) {
				return item.renewalPrice;
			});
		};

		$scope.autoRenewPrice = function () {
			return $scope.manualRenewPrice() * 0.9; // FIX!!! hard-coded
		};

		/**
		 * What the customer is charged today for a monthly subscription: the cart total, which the server has already
		 * divided down to one month. Perpetual licenses never take this path.
		 * @return {number}
		 */
		/**
		 * What one subscription charge costs. The cart line is already priced for the plan on the cart, so this is
		 * just the order total -- but what it is called depends on the plan.
		 */
		$scope.perPeriodChargeAmount = function () {
			return $scope.totalOrderPrice();
		};

		function billingPeriodOption() {
			return BILLING_PERIODS.find(o => o.id === ($scope.cart.billingPeriod || 'Annual'))
				|| BILLING_PERIODS[BILLING_PERIODS.length - 1];
		}

		/** @return {string} "month" or "year" -- the term one charge buys */
		$scope.billingTermNoun = function () {
			return billingPeriodOption().termNoun;
		};

		/** @return {string} "monthly" or "annually" */
		$scope.billingAdverb = function () {
			return billingPeriodOption().adverb;
		};

		/** The plans a subscription customer may pick from. Retired plans are not offered, only displayed. */
		$scope.billingPeriodChoices = BILLING_PERIODS.filter(o => o.offered);

		/**
		 * Line items priced for each plan, keyed by period, so both prices are the server's own figures and switching
		 * between them is instant.
		 * @type {Object<string, CartAction[]>}
		 */
		const cartActionsByPeriod = {};

		/** @return {number|null} what one charge on this plan costs, or null until the server has priced it */
		$scope.planPrice = function (billingPeriod) {
			const cartActions = cartActionsByPeriod[billingPeriod];
			return cartActions ? lineItemSum(cartActions, extendedPrice) : null;
		};

		/** @return {string|null} how the amounts in the cart are billed, for a subscription. Perpetual carts say nothing. */
		$scope.billingCartNote = function () {
			return $scope.askBillingPeriod || $scope.isAnnualSubscription() ? 'Billed ' + $scope.billingAdverb() : null;
		};

		/**
		 * Perpetual licenses are billed annually, and the only question is whether renewal is automatic.
		 * @param planId {'Annual'|'Manual'}
		 */
		$scope.chooseBillingPlan = function (planId) {
			$scope.tmp.billingPlan = planId;
			$scope.cart.autoRenew = planId !== 'Manual';
			$scope.cart.billingPeriod = 'Annual';
		};

		/**
		 * A subscription customer picks how often they are billed, and the cart switches to the line items the server
		 * priced for that period.
		 * @param billingPeriod {'Monthly'|'Annual'}
		 */
		$scope.chooseBillingPeriod = function (billingPeriod) {
			$scope.tmp.billingPlan = billingPeriod;
			priceCartForPeriod(billingPeriod).then(function (cartActions) {
				$scope.cartActions = session.replaceCartActions(cartActions);
				$scope.cart.billingPeriod = billingPeriod;
			});
		};

		/**
		 * @param billingPeriod {'Monthly'|'Annual'}
		 * @return {Promise<CartAction[]>} this cart's line items priced for that plan, asking the server only once
		 */
		function priceCartForPeriod(billingPeriod) {
			if (cartActionsByPeriod[billingPeriod]) {
				return $q.when(cartActionsByPeriod[billingPeriod]);
			}
			return api.getCartForCheckout($scope.cartActions, billingPeriod).then(function (response) {
				cartActionsByPeriod[billingPeriod] = response.cartActions;
				return response.cartActions;
			});
		}

		$scope.isAnnualSubscription = function () {
			// If any action in the cart is marked as annual pricing, the whole cart is treated as such.
			// return $scope.cartActions?.some(action => action.annualPricing);
			return $scope.licenseType() === 'MirrorSync'; // FIX!! hard-coded
		};

		$scope.buyingForCustomer = function () {
			$scope.tmp.buyingFor = 'customer';
			$uibModal.open({
				controller: 'ModalResellerCheckoutCtrl',
				templateUrl: 'views/modal-reseller-checkout.html?v=' + BUILD_DATE,
				size: 'lg',
				scope: $scope,
			}).result.catch(function () {
				$scope.tmp.buyingFor = null;
			});
		};

		// $scope.removeCartItem = function (index) {
		// 	session.removeCartItem(index);
		// 	redirectIfCartIsEmpty();
		// };

		// event sent from shopping-cart component
		$scope.$on('remove-cart-action', function (event, cartAction) {
			session.removeCartAction(cartAction);
			redirectIfCartActionsIsEmpty();
		});

		// event sent from shopping-cart component
		$scope.$on('remove-promo', function () {
			$scope.cart.promoCode = null;
		});

		/**
		 * @return {'MirrorSync' | 'Maintenance' | 'Portfolio'}
		 */
		$scope.licenseType = () => {
			let firstAction = $scope.cartActions[0].action;
			if (firstAction === 'MirrorSync') {
				return 'MirrorSync';
			} else if (firstAction === 'Portfolio') {
				return 'Portfolio';
			} else if (firstAction === 'Renew' && $scope.cartActions[0].mirrorSyncRequest) {
				return 'MirrorSync';
			} else {
				return 'Maintenance';
			}
		};

		$scope.applyPromoCode = function (code) {
			code = code.replaceAll(/[^a-zA-Z0-9]/g, '');
			api.getPromoCode(code).then(function (promo) {
				Analytics.trackEvent('promo', 'success', code, promo.name);
				//I'm disabling the select_promotion event for applying promo codes, because this isn't what select_promotion is for, and it confused GA4 --wgs
				//Analytics.select_promotion(promo.name, promo.code);
				if (promo.affiliate && !$scope.cart.commissionChoice) {
					$scope.buyingForCustomer(); // must log in and choose
				} else {
					$scope.cart.promoCode = promo;
				}
				toastr.success('Your promo code has been applied!', 'Promotional Code');
			}, function (error) {
				$scope.cart.promoCode = null;
				Analytics.trackEvent('promo', 'fail', code, error);
			});
		};

		$scope.submit = function () {
			$scope.myForm.$setSubmitted();
			if ($scope.myForm.$invalid) {
				if ($scope.myForm.$error.ccExp) {
					toastr.warning('Credit card expiration must be in the future');
				} else {
					toastr.warning('Please fix validation errors');
				}
				return;
			}

			if ($scope.isInvalidPaymentMethod()) {
				return toastr.warning($scope.invalidPaymentMethodMessage(), 'Invalid Payment Method / Auto-Renew');
			}
			const tmpCart = angular.copy($scope.cart); // assemble the pieces into something back-end-friendly
			const cc = tmpCart.paymentDatas[0].creditCard;
			if (tmpCart.paymentDatas[0]?.paymentMethod === 'creditCard' && cc && $scope.totalOrderPrice() > 0.0) {
				if (!$scope.tmp.cardpointePaymentToken) {
					return toastr.warning('Please complete the credit card entry section', 'Missing / Invalid Credit Card');
				}
				cc.cardpointePaymentToken = $scope.tmp.cardpointePaymentToken;
				// old code from when we captured cc numbers like non-PCI-compliant cavemen
				// cc.ccNumber = $scope.tmp.ccNumber;
				// cc.securityCode = $scope.tmp.cvv;
				// cc.expiration = $scope.creditCard.expirationYear + '-' + $scope.creditCard.expirationMonth + '-01';
				// cc.cardType = $scope.myForm.cardNumber.$ccType;
				// if (cc.ccExpirationYear.length === 2) {
				// 	cc.ccExpirationYear = parseInt(cc.ccExpirationYear) + 2000;
				// }
			}

			const progress = $uibModal.open({
				templateUrl: 'views/modal-checking-out-progress.html?v=' + BUILD_DATE,
				size: 'lg',
				scope: $scope,
			});

			const timeSpent = new Date().getTime() - startTime;
			api.checkout({cartActions: $scope.cartActions, cart: tmpCart}).then(function (/** CheckoutResponse | CheckoutResponseStripe3DS */checkoutResponse) {

				if (checkoutResponse.action === '3DS_REDIRECT') {
					if (!checkoutResponse.acsUrl) {
						toastr.error('Payment Gateway Error: 3DS Redirect URL is missing.');
						return;
					}
					Analytics.trackEvent('cart', '3dsRedirect');
					const form = document.createElement('form');
					form.method = 'POST';
					form.action = checkoutResponse.acsUrl;
					form.style.display = 'none';

					const addField = (name, val) => {
						const input = document.createElement('input');
						input.type = 'hidden';
						input.name = name;
						input.value = val;
						form.appendChild(input);
					};

					addField('PaReq', checkoutResponse.paReq);
					addField('TermUrl', checkoutResponse.termUrl);
					addField('MD', checkoutResponse.md);

					document.body.appendChild(form);
					form.submit(); // Bye bye! Redirecting to bank.
					return;
				}

				if (checkoutResponse.action === '3DS_STRIPE') {
					progress.close();
					Analytics.trackEvent('cart', '3dsStripe');
					$scope.openStripe3DSModal(checkoutResponse, tmpCart, $scope.cartActions);
					return;
				}

				Analytics.purchase(tmpCart, $scope.cartActions, checkoutResponse);
				Analytics.trackEvent('cart', 'timeToCheckout', 'elapsedTime', timeSpent, null);
				if (tmpCart.autoRenew) {
					Analytics.join_group('autoRenew');
				}
				if (tmpCart.paymentDatas?.[0]?.person?.sendUpdates) {
					Analytics.join_group('receiveUpdates');
				}

				session.clearCart();
				$location.path('/receipt')
					.search('cartId', checkoutResponse.cartId)
					.search('licenseKey', checkoutResponse.licenseKey)
					.search('registeredTo', checkoutResponse.registeredTo);
				if (checkoutResponse.warnings) {
					checkoutResponse.warnings.forEach(function (m) {
						toastr.warning(m.message, m.title);
					});
				}
			}, function () {
				// $scope.tmp.buyingFor = null;
				progress.close();
			}).finally(progress.close);
		};

		$scope.openStripe3DSModal = function (stripe3DSResponse, originalCart, cartActions) {
			stripe3ds.challenge(stripe3DSResponse).then(function (checkoutResponse) {
				Analytics.purchase(originalCart, cartActions, checkoutResponse);
				session.clearCart();
				$location.path('/receipt')
					.search('cartId', checkoutResponse.cartId)
					.search('licenseKey', checkoutResponse.licenseKey)
					.search('registeredTo', checkoutResponse.registeredTo);
				if (checkoutResponse.warnings) {
					checkoutResponse.warnings.forEach(function (m) {
						toastr.warning(m.message, m.title);
					});
				}
			}, function (reason) {
				if (reason === 'cancel') {
					toastr.warning('Verification cancelled. Your card has not been charged.');
				}
			});
		};

		$scope.generateQuote = () => {
			if (!$scope.person.company && !$scope.paymentData.purchasingCompany) {
				return toastr.warning('Please enter a company name');
			}
			if (!window.confirm('This will generate a quote for your cart items. Do you want to continue?')) {
				return;
			}
			const progress = $uibModal.open({
				templateUrl: 'views/modal-checking-out-progress.html?v=' + BUILD_DATE,
				size: 'lg',
				scope: $scope,
			});
			const tmpCart = angular.copy($scope.cart); // assemble the pieces into something back-end-friendly
			Analytics.trackEvent('cart', 'generateQuote');
			api.generateQuote({cartActions: $scope.cartActions, cart: tmpCart}).then(function (/**string*/quoteUrl) {
				window.location.href = quoteUrl;
			}, function () {
				progress.close();
			}).finally(progress.close);
		};

		/*
		///////////////////////////////////////////////////////////////////////////
		// INIT
		///////////////////////////////////////////////////////////////////////////
		*/
		$scope.countries = COUNTRIES;

		$scope.tmp = {
			// buyingFor: undefined, // 'self', // FIX! turn this back on
			buyingFor: 'self',
			cardpointePaymentToken: '',
			/** @type {'Monthly'|'Annual'|'Manual'|null} unset until the customer picks a plan */
			billingPlan: null,
		};
		/**
		 * @type {CartAction[]}
		 */
		$scope.cartActions = session.cartActions;
		Analytics.begin_checkout($scope.cartActions);

		redirectIfCartActionsIsEmpty();

		$scope.isPaymentSelectEnabled = () => {
			return $location.search()?.['enable-beta-features'];
		};

		$scope.cart = {autoRenewFailed: false, status: 0};

		/** Whether to ask the customer how they want to be billed. Only a new subscription gets a say. */
		$scope.askBillingPeriod = false;

		api.getCartForCheckout($scope.cartActions)
			.then(response => {
				const cart = response.cart;
				$scope.cart = cart;
				$scope.cartActions = session.replaceCartActions(response.cartActions); // prices as the server sees them
				cartActionsByPeriod[cart.billingPeriod] = response.cartActions;
				$scope.askBillingPeriod = response.offersBillingPeriodChoice;
				if ($scope.askBillingPeriod) {
					// price every plan up front, so the customer compares real numbers instead of picking blind
					$scope.billingPeriodChoices.forEach(o => priceCartForPeriod(o.id));
				}
				$scope.paymentData = cart.paymentDatas[0] || {};
				if (cart.companyOverride) {
					$scope.paymentData.person = $scope.paymentData.person || {sendUpdates: undefined};
					$scope.paymentData.person.company = cart.companyOverride; // locked
					$scope.tmp.buyingFor = 'self'; // cannot switch upgrade to another company
				}
				$scope.person = $scope.paymentData.person;
				if (!$scope.paymentData.creditCard) {
					$scope.paymentData.creditCard = {};
				}
				$scope.creditCard = $scope.paymentData.creditCard;

				$scope.disableFields = false;

				// a subscription the customer gets no say over (an add-on to an existing license) is billed on that
				// license's plan; marking the choice as made lets the rest of the form show
				if ($scope.tmp.billingPlan == null && $scope.isAnnualSubscription() && !$scope.askBillingPeriod) {
					$scope.tmp.billingPlan = cart.billingPeriod || 'Monthly';
				}

				if ($scope.isFree()) {
					$scope.tmp.buyingFor = 'self'; // no need to ask
				}
			});

	});
